var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternLeftTop(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pattern-left-top_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 240 144",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pattern-left-top_svg__st2{fill:#4f25b7}.pattern-left-top_svg__st5{fill:#6c36db}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9c0-5 4-9 9-9h39v48H0V9z",
    fill: "#ad78ff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pattern-left-top_svg__st2",
    d: "M144 48h48v48h-48V48zM96 96h48v48H96V96zM192 0h48v48h-48V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 48h-48V24h24V0h24v48z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#c193ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 48H48v24h24v24h24V48z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ad78ff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pattern-left-top_svg__st5",
    d: "M0 96h48L0 144V96zM48 96h48l-48 48V96zM144 48H96V0c26.5 0 48 21.5 48 48z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternLeftTop);
export default "/_next/static/images/b42e1a02e95e33dfff2fe95775daab6d.svg";
export { ForwardRef as ReactComponent };